module.exports = __webpack_public_path__ + "static/media/ts13cr0.3cb1dd17.png";